import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { BiEdit } from "react-icons/bi";
import { IoPlayForwardCircle } from "react-icons/io5";
import { FcCalendar } from "react-icons/fc";
import moment from "moment";
import { DatePicker } from "antd";
import { readingDateDisableCondition } from "@src/helpers/constants";
import {
  AppDispatch,
  dynamicSet,
  getReadingList,
  getSubject,
  updateNextScreeningDateRequest,
  updateSubjectRequest,
} from "@src/redux";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { useParams } from "react-router-dom";

type Props = {};

const DetailsMobileHeaderFirstRow = (props: Props) => {
  const { t } = useTranslation();
  const { result: subject } = useSelector(getSubject);
  const [selectedDate, setSelectedDate] = useState("");
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const { result: readingList } = useSelector(getReadingList);
  const dispatch = useDispatch<AppDispatch>();
  const { id } = useParams();

  const handleDateChange = (date: Date | null) => {
    if (date) {
      const formattedDate = moment(date).format("YYYY-MMM-DD");
      setSelectedDate(formattedDate);
    }
    setIsDatePickerOpen(false);
  };

  const handleChange = (date: any) => {
    dispatch(
      updateNextScreeningDateRequest({
        id: id || "",
        data: { nextReadingDate: date },
      })
    );
  };

  const disablePastDates = (date: dayjs.Dayjs) => {
    return date && date.isBefore(dayjs().startOf("day"));
  };
  const handleClick = () => {
    dispatch(
      dynamicSet("get_reading_details", {
        reading: readingList?.items?.[readingList?.items?.length - 1],
      })
    );
  };
  return (
    <>
      <div className="mobile_details_screening_date_box details_screening_date_box">
        <div className="details_last_screening_container">
          <span className="details_last_screening_text">
            {t("next_screening")}
          </span>
        </div>
        <div className="details_screening_icon_container">
          <div style={{ position: "absolute", zIndex: 9 }}>
            <DatePicker
              variant="borderless"
              onChange={handleChange}
              value={
                subject?.nextReadingDate
                  ? dayjs(subject?.nextReadingDate)
                  : null
              }
              format={"DD-MM-YYYY"}
              suffixIcon={<BiEdit color="white" size={18} />}
              readOnly
              className="user-subject-date-picker"
              allowClear={false}
              disabledDate={(date: any) => disablePastDates(date)}
              placement="topLeft"
              defaultPickerValue={dayjs()}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailsMobileHeaderFirstRow;
